import Cookie from 'js-cookie';

export const startCommonCookieLogic = (lang) => {
  /**
   * При переходе на авиа, nginx принудительно выставляет referrer = '', если отсутствует кука языка.
   * Добавляем куку, чтобы при переходе не слетал referrer
   */
  Cookie.set('accept_language', lang || 'ru');
};
